/**
 * Created by Jerker Nord on 2024-01-08.
 */
import {Loner} from "../../../../Loner";
import {LonerGameAssets} from "../../../../LonerGameAssets";
import {gsap} from "gsap";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {LonerDuckAnimator} from "../LonerDuckAnimator";
import {LonerSSDMainView} from "../LonerSSDMainView";

export class LonerDuckSymbol extends PIXI.Container{

    protected MULTIPLIER_TEXT_LEFT_POSITION:PIXI.Point = new PIXI.Point(-20, -70);
    protected MULTIPLIER_TEXT_RIGHT_POSITION:PIXI.Point = new PIXI.Point(+20, -70);

    private _reel:number;
    private _row:number;
    private _flickerTL:gsap.core.Timeline;

    protected _burnTextureName:string;
    protected _symbolSprite:PIXI.Sprite;
    protected _multiplierText:PIXI.BitmapText;
    protected _multiplierValue:number = 0;
    protected _isUsed:boolean;
    protected _direction:string;
    protected _symbolName:string;
    protected _explosionImage:PIXI.Sprite;
    private _isShot:boolean;

    constructor() {
        super();
        this.init();
    }

    protected init():void {
        this._isUsed = false;
        this._isShot = false;

        this._symbolSprite = new PIXI.Sprite();
        this._symbolSprite.anchor.set(0.5, 0.5);
        this.addChild(this._symbolSprite);

        this.createMultiplierText();

        this._explosionImage = new PIXI.Sprite(Loner.assetLoader.getTextures(LonerGameAssets.SSD_SYMBOL_EXPLOSION)[0]);
        this._explosionImage.anchor.set(0.5, 0.5);
        this._explosionImage.visible = false;
        this.addChild(this._explosionImage);

        this._flickerTL = gsap.timeline({repeat : -1});
        this._flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.04, 0.03, 2)}));
        this._flickerTL.add(() => {
            this._multiplierText.alpha = MathHelper.randomNumberInRange(0.8, 1, 2);
        });
        this._flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.04, 0.02, 2)}));
        this._flickerTL.add(() => {
            this._multiplierText.alpha = MathHelper.randomNumberInRange(0.8, 1, 2);
        });
        this._flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.04, 0.03, 2)}));
        this._flickerTL.add(() => {
            this._multiplierText.alpha = MathHelper.randomNumberInRange(0.8, 1, 2);
        });
    }

    protected createMultiplierText():void{
        this._multiplierText = new PIXI.BitmapText("x1", {
            fontName : LonerGameAssets.BITMAP_FONT_SSD_MULTIPLIER,
            fontSize : 40
        });
        this._multiplierText.anchor = new PIXI.Point(0.5, 0.5);
        this._multiplierText.visible = false;
        this.addChild(this._multiplierText);
    }

    public getSymbolShotTL():gsap.core.Timeline {
        const symbolShotTL:gsap.core.Timeline = gsap.timeline();
        symbolShotTL.add(() => {
            this._explosionImage.visible = true;
            this._isShot = true;
        });
        symbolShotTL.add(gsap.timeline({delay : 0.2}));
        symbolShotTL.add(() => {
            this.setSymbol(LonerDuckAnimator.DUCK_BASE_PATH +
                Loner.ssdMainView.getDuckValuePath(this._multiplierValue, this._symbolName) +
                LonerGameAssets.SSD_EXPLODED_DUCKS[MathHelper.randomIntInRange(0, LonerGameAssets.SSD_EXPLODED_DUCKS.length - 1)] +
                this.direction)
        });
        symbolShotTL.add(()=>{
            this._multiplierValue = 0;
        });
        symbolShotTL.add(() => {this._explosionImage.visible = false});
        symbolShotTL.add(() => {this._multiplierText.visible = false});

        return symbolShotTL;
    }

    public getSymbolBurntTL():gsap.core.Timeline {
        const burntTL:gsap.core.Timeline = gsap.timeline();
        if(this.isShot == true) {
            return burntTL;
        }
        burntTL.add(() => {
            this._symbolSprite.texture = Loner.assetLoader.getTextures(this._burnTextureName)[0];
        });

        return burntTL;
    }

    public setSymbol(textureName:string):void {
        this._symbolSprite.texture = Loner.assetLoader.getTextures(textureName)[0];
        this.name = textureName;
        this._burnTextureName = this.name + "_burn";
    }

    public setMultiplier(value:number):void {
        if(LonerSSDMainView.NO_MULTIPLIER_DUCKS.includes(this.symbolName) || this._isShot) {
            return;
        }
        this._multiplierText.text = "x" + value.toString();
        this._multiplierText.visible = true;
        this._multiplierValue = value;
    }

    public movingDuck():void {
        if(this.row == 0 || this.row == 2) {
            this.reel--;
        } else {
            this.reel++;
        }
    }

    public reset():void {
        this._multiplierText.visible = false;
        this._isShot = false;
        this._isUsed = false;
        this._multiplierValue = 0;
    }

    get isUsed():boolean {
        return this._isUsed;
    }

    set isUsed(value:boolean) {
        this._isUsed = value;
    }

    get direction():string {
        return this._direction;
    }

    set direction(value:string) {
        if(value == LonerDuckAnimator.DIRECTION_LEFT) {
            this._multiplierText.position = this.MULTIPLIER_TEXT_LEFT_POSITION;
        } else {
            this._multiplierText.position = this.MULTIPLIER_TEXT_RIGHT_POSITION;
        }
        this._direction = value;
    }

    get symbolName():string {
        return this._symbolName;
    }

    set symbolName(value:string) {
        this._symbolName = value;
    }

    get reel():number {
        return this._reel;
    }

    set reel(value:number) {
        this._reel = value;
    }

    get row():number {
        return this._row;
    }

    set row(value:number) {
        this._row = value;
    }

    get isShot():boolean {
        return this._isShot;
    }

    set isShot(value:boolean) {
        this._isShot = value;
    }

    get multiplierValue():number {
        return this._multiplierValue;
    }

    set multiplierValue(value:number) {
        this._multiplierValue = value;
    }
}